import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { User } from './models';
// import addresses from './modules/addresses';
// import controllers from './modules/controllers';
// import mcsWithReports from './modules/mcsWithReports';
// import statistics from './modules/statistics';
// import subscriptions from './modules/subscriptions';
// import supports from './modules/supports';
// import users from './modules/users';
// import { mapState } from 'vuex';
import { Controller } from './models';

Vue.use(Vuex);

Vue.config.devtools = process.env.NODE_ENV === 'development';

// const vuexLocal = new VuexPersistence({
//   strictMode: true,
//   storage: window.localStorage
// });

// TODO wait to be commited https://github.com/championswimmer/vuex-module-decorators/pull/102

export default new Vuex.Store({
  plugins: [createPersistedState({
    // storage: window.sessionStorage
  })],
  // plugins: [vuexLocal.plugin],
  // plugins: [new VuexPersistence().plugin],
  // plugins: [createPersistedState({
  //   getState: (key) => {
  //     const res = Cookies.getJSON(key)
  //     console.log(`getState ${key}: ${res}`);
  //     return res;
  //   },
  //   setState: (key, state) => Cookies.set(key, state, { expires: 3, secure: false })
  // })],
  strict: process.env.NODE_ENV !== 'production',
  // modules: [
  //   // auth,
  // ],
  modules: {
    // addresses,
    // controllers,
    // mcsWithReports,
    // statistics,
    // subscriptions,
    // supports,
    // users,
  },

  state: {
    loggedIn: false,
    user: {} as User,
    jwt: {},
  },

  mutations: {
    // RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
    login(state, user): void {
      state.user = user as User;
      state.loggedIn = true;
    },

    logout(state): void {
      state.user = {} as User;
      state.loggedIn = false;
      state.jwt = {};
      // state.users
    },

    setJWT(state, jwt): void {
      state.jwt = jwt;
    },

    clearJWT(state): void {
      state.jwt = {};
    },
  },

  actions: {

  },

  getters: {
    loggedIn: (state) => state.loggedIn,
    user: (state) => state.user,
    jwt: (state) => state.jwt,
  },
});
